import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="border-t border-slate-800 bg-slate-950 text-slate-400" data-id="element-72" data-mp="3gezdb400vr15">
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-73" data-mp="3gh3rqfvjs8fo">
        <p className="text-xs" data-id="element-74" data-mp="32pff8bhdzhy6">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}